import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Collapse, Paper, Typography } from '@mui/material';
import * as icons from 'mdi-material-ui';

const ExpandableList = props => {
    const { children, title, onCollapse, defaultOpen, sx, collapseProps } = props;

    const [expanded, setExpanded] = useState(defaultOpen || false);
    const handleToggleExpand = useCallback(() => {
        setExpanded(prevState => {
            onCollapse?.();
            return !prevState;
        });
    }, [onCollapse]);

    return (
        <Paper
            elevation={1}
            sx={theme => ({
                border: theme => `1px solid ${theme.palette.grey[100]}`,
                borderRadius: 2,
                p: 2,
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
                onClick={handleToggleExpand}
            >
                <Typography color="primary" sx={{ display: 'flex', fontSize: 18 }}>
                    <icons.ChevronRight
                        sx={{
                            fontSize: 24,
                            transition: 'transform .2s',
                            transform: expanded ? 'rotate(90deg)' : 'none',
                        }}
                    />
                </Typography>
                <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>{title}</Typography>
            </Box>
            <Collapse in={expanded} {...collapseProps}>
                {children}
            </Collapse>
        </Paper>
    );
};

ExpandableList.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string.isRequired,
    onCollapse: PropTypes.func,
    defaultOpen: PropTypes.bool,
};

export default ExpandableList;
